import {
    apiTransitionPaystack,
    apiTransitionPaystackStatus,
    checkPaymentsStatus,
    checkPaystackStatusSuccess,
    initPayments,
    submitPaymentSuccess,
    submitPaystackPayments,
} from '../../../actions/personalAccident/paystack';
import { setExpiredAuth } from '../../../actions/personalAccident/quote';
import {
    getAccessToken,
    getPaymentsForm,
    getStkData,
    getStatusApiCallStatus,
    getNetworkProvider,
    getPaystackIsApiPending,
    getPaystackStatusIsApiPending,
    getPaystackStatusIsApiStatus,
    getPaystackData,
} from '../../../selectors/personalAccident/payments';
import { getCustomerIdValue } from '../../../selectors/personalAccident/personalDetails';
import axios from 'axios';
import { getPremiumCalculation } from '../../../selectors/personalAccident/quote';
import { confirmOrderSuccess } from '../../../actions/personalAccident/payments';

const clearIntervalId = (intervalId) => {
    clearInterval(intervalId);
};

let intervalId = null;

// ---------------------------- INITIATE PAYMENT --------------------
export const paystackPaymentService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (!getPaystackIsApiPending(state)) {
            store.dispatch(apiTransitionPaystack.pending());
            try {
                const resp = await initiatePaystackPayments(state);
                store.dispatch(submitPaymentSuccess(resp.data));
                store.dispatch(apiTransitionPaystack.success());
                intervalId = setInterval(() => {
                    store.dispatch(checkPaymentsStatus());
                    if (getPaystackStatusIsApiStatus(state) === 'success') {
                        clearIntervalId(intervalId);
                    }
                }, 5000);
                setTimeout(() => {
                    if (intervalId) {
                        clearIntervalId(intervalId);
                        store.dispatch(submitPaystackPayments());
                        store.dispatch(apiTransitionPaystackStatus.failure());
                        return;
                    }
                }, 240000);
            } catch (e) {
                store.dispatch(apiTransitionPaystack.failure());
                clearIntervalId(intervalId);
            }
        }
    })();
    return result;
};

const initiatePayload = (state) => {
    const quoteId = getCustomerIdValue(state);
    const premiumCalculation = getPremiumCalculation(state);
    const amount = premiumCalculation?.value || 'N/A';

    const payload = {
        quote_id: quoteId.value,
        amount: amount,
        product_category: 'PERSONAL_ACCIDENT',
        product_code: 'PERSONAL_ACCIDENT',
    };

    return {
        ...payload,
    };
};

const initiatePaystackPayments = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/personal-accident/paystack-initiate';

        return await axios.post(url, initiatePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        throw e;
    }
};
// ---------------------------- END ---------------------------------

// ---------------------------- CHECK PAYMENTS STATUS ----------------
export const paystackStkStatusService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (getPaystackStatusIsApiStatus(state) === 'success') {
            clearIntervalId(intervalId);
            intervalId = null;
            return;
        }
        if (!getPaystackStatusIsApiPending(state)) {
            store.dispatch(apiTransitionPaystackStatus.pending());
            try {
                const resp = await triggerStkStatusCheck(state);
                if (resp.data && resp.data.success) {
                    if (resp.data.data.data.status === 'success') {
                        clearIntervalId(intervalId);
                        intervalId = null;
                        store.dispatch(checkPaystackStatusSuccess(resp.data));
                        store.dispatch(submitPaystackPayments());
                        store.dispatch(apiTransitionPaystackStatus.success());
                    } else {
                        store.dispatch(apiTransitionPaystackStatus.initialize());
                    }
                    return;
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                //store.dispatch(apiTransitionPaymentsStatus.failure());
                console.error(e.response);
                //store.dispatch(checkPaymentsStatusFailure(e.response));
                return e;
            }
        }
    })();

    return result;
};

const paystackStatusPayload = (state) => {
    const paystackData = getPaystackData(state);

    const payload = {
        reference_code: paystackData.response.data.reference || null,
    };

    return {
        ...payload,
    };
};

const triggerStkStatusCheck = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-accident/paystack-status';
        return await axios.post(url, paystackStatusPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

// ---------------------------- END ---------------------------------

// ---------------------------- SUBMIT PAYMENTS --------------------

export const submitPaymentService = (store, next, action) => {
    (async () => {
        try {
            const resp = await triggerSubmit(store.getState());
            if (resp.data && resp.data.status === 200) {
                // store.dispatch(confirmOrderSuccess(resp.data));
            }
        } catch (e) {
            console.error(e);
        }
    })();

    return next(action);
};

const paystackSubmitPayload = (state) => {
    const paystackData = getPaystackData(state);
    const pid = getCustomerIdValue(state);

    const payload = {
        quote_id: pid.value,
        reference_code: paystackData.response.data.reference || null,
    };
    return {
        ...payload,
    };
};

const triggerSubmit = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-accident/paystack-payment-submit';
        return await axios.post(url, paystackSubmitPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
// ---------------------------- END -------------------
